export const getAuthConfirmRedirectUrl = (siteUrl?: string, next?: string) => {
  return siteUrl
    ? `${siteUrl}/auth/confirm${next ? `?next=${siteUrl}${next}` : ""}`
    : "";
};

export const getAuthContinueRedirectUrl = (siteUrl?: string, next?: string) => {
  return siteUrl
    ? `${siteUrl}/auth/continue${next ? `?next=${siteUrl}${next}` : ""}`
    : "";
};
